import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class FsaContact {
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  email?: string
}
